import { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn, dispatchLead } from "../../lib/utils";
import icon from "../../assets/icons/telegram.svg";
// import externalIcon from "../../assets/icons/external.svg";

export type TelegramButtonProps = ComponentPropsWithoutRef<"a"> & {
  href: string;
  ariaLabel: string;
  children: ReactNode;
};

export const TelegramButton = ({
  href,
  ariaLabel,
  className,
  children,
  ...props
}: TelegramButtonProps) => {
  const onClick = dispatchLead(() => {
    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", "all");
      url.searchParams.set("wppButtonText", "GRUPO DO WHATSAPP");
      window.location.href = url.toString();
    }, 100);
  });

  return (
    <a
      role="button"
      className={cn("cta-button", className)}
      aria-label={ariaLabel}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      {...props}
    >
      <span className="flex items-center gap-4 justify-center">
        <img src={icon} alt="Ícone Telegram" className="w-7 h-7" />
        {children}
        {/* <img src={externalIcon} alt="Ícone externo" className="w-6 h-6" /> */}
      </span>
    </a>
  );
};
